import {
	collection,
	doc,
	getDoc,
	getDocs,
	query,
	updateDoc,
	where,
	arrayUnion,
	Timestamp,
} from "firebase/firestore";
import { db } from "../../../../services/firebase/config";
import { COLLECTIONS } from "../constants/assignment.constants";
import { nowTimestamp } from "../utils/timestamp.utils";

// ─── Fetch all assignments for a specific warehouse user ──────────────────────
export const fetchAssignmentsByUser = async (assignedTo) => {
	const q = query(
		collection(db, COLLECTIONS.ASSIGNMENTS),
		where("assignedTo", "==", assignedTo),
	);
	const snap = await getDocs(q);
	return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
};

// ─── Fetch a single assignment by ID ─────────────────────────────────────────
export const fetchAssignmentById = async (assignmentId) => {
	const ref = doc(db, COLLECTIONS.ASSIGNMENTS, assignmentId);
	const snap = await getDoc(ref);
	if (!snap.exists()) return null;
	return { id: snap.id, ...snap.data() };
};

// ─── Fetch order details by order ID ─────────────────────────────────────────
export const fetchOrderById = async (orderId) => {
	const ref = doc(db, COLLECTIONS.ORDERS, orderId);
	const snap = await getDoc(ref);
	if (!snap.exists()) return null;
	return { id: snap.id, ...snap.data() };
};

// ─── Update assignment: items + currentStatus ─────────────────────────────────
export const updateAssignment = async (
	assignmentId,
	updatedItems,
	newStatus,
) => {
	const ref = doc(db, COLLECTIONS.ASSIGNMENTS, assignmentId);
	const payload = { items: updatedItems };
	if (newStatus) payload.currentStatus = newStatus;
	await updateDoc(ref, payload);
};

// ─── Append a new remark to assignment.remarks array ─────────────────────────
export const addAssignmentRemark = async (assignmentId, remark) => {
	const ref = doc(db, COLLECTIONS.ASSIGNMENTS, assignmentId);
	await updateDoc(ref, {
		remarks: arrayUnion({
			comment: remark.comment,
			updatedBy: remark.updatedBy,
			updatedAt: nowTimestamp(),
		}),
	});
};

// ─── Append a new status entry to order.orderDetails.orderStatus ──────────────
export const appendOrderStatus = async (orderId, statusEntry) => {
	const ref = doc(db, COLLECTIONS.ORDERS, orderId);
	// Firestore arrayUnion on nested field path requires a field path string
	await updateDoc(ref, {
		"orderDetails.orderStatus": arrayUnion({
			currentStatus: "In Progress",
			updatedBy: statusEntry.updatedBy,
			assignmentId: statusEntry.assignmentId,
			stateUpdatedAt: nowTimestamp(),
			remarks: statusEntry.remarks,
		}),
	});
};
